import React, {
  useEffect,
} from "react";

import {
  FaCrown,
  FaTimes,
} from "react-icons/fa";

import TenantSubscriptionPage from "./TenantSubscriptionPage";

import "./SubscriptionPopup.css";


const SubscriptionPopup = ({
  onClose,
  onSubscriptionSuccess,
}) => {

  /*
  |--------------------------------------------------------------------------
  | LOCK PAGE SCROLL
  |--------------------------------------------------------------------------
  */

  useEffect(
    () => {

      const oldOverflow =
        document
          .body
          .style
          .overflow;


      document
        .body
        .style
        .overflow =
        "hidden";


      return () => {

        document
          .body
          .style
          .overflow =
          oldOverflow;

      };

    },
    []
  );


  /*
  |--------------------------------------------------------------------------
  | ESC CLOSE
  |--------------------------------------------------------------------------
  */

  useEffect(
    () => {

      const handleKeyDown =
        (
          event
        ) => {

          if (
            event.key ===
            "Escape"
          ) {

            if (
              typeof onClose ===
              "function"
            ) {

              onClose();

            }

          }

        };


      window.addEventListener(
        "keydown",
        handleKeyDown
      );


      return () => {

        window.removeEventListener(
          "keydown",
          handleKeyDown
        );

      };

    },
    [
      onClose,
    ]
  );


  return (

    <div className="subscription-popup">

      {/* ================================================================
          OVERLAY
      ================================================================ */}

      <div
        className="subscription-popup__overlay"

        onClick={
          () => {

            if (
              typeof onClose ===
              "function"
            ) {

              onClose();

            }

          }
        }
      />


      {/* ================================================================
          DIALOG
      ================================================================ */}

      <div className="subscription-popup__dialog">

        {/* ==============================================================
            POPUP HEADER
        ============================================================== */}

        <div className="subscription-popup__header">

          <div className="subscription-popup__header-left">

            <div className="subscription-popup__header-icon">

              <FaCrown />

            </div>


            <div>

              <span className="subscription-popup__eyebrow">
                COMKWIK SUBSCRIPTION
              </span>


              <h2>
                Choose your business plan
              </h2>

            </div>

          </div>


          {/* ============================================================
              CLOSE
          ============================================================ */}

          <button
            type="button"

            className="subscription-popup__close"

            onClick={
              () => {

                if (
                  typeof onClose ===
                  "function"
                ) {

                  onClose();

                }

              }
            }

            aria-label="Close subscription popup"
          >

            <FaTimes />

          </button>

        </div>


        {/* ================================================================
            BODY
        ================================================================ */}

        <div className="subscription-popup__body">

          <TenantSubscriptionPage

            embedded

            onSubscriptionSuccess={
              onSubscriptionSuccess
            }

          />

        </div>

      </div>

    </div>

  );

};


export default SubscriptionPopup;